import {
  ESCALATION_ORDER_LIST_REQUEST,
  ESCALATION_ORDER_LIST_SUCCESS,
  ESCALATION_ORDER_LIST_FAIL,
} from '../constants/escalationConstants';

export const escalationOrderListReducer = (state = { escalationOrders: [] }, action) => {
  switch (action.type) {
    case ESCALATION_ORDER_LIST_REQUEST:
      return { loading: true, escalationOrders: [] };
    case ESCALATION_ORDER_LIST_SUCCESS:
      return { loading: false, escalationOrders: action.payload };
    case ESCALATION_ORDER_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};